import {
  DataTable,
  Button,
  Layout,
  LegacyCard,
  InlineStack,
  Text,
  TextField,
  BlockStack,
  ButtonGroup,
} from "@shopify/polaris";
import { useState, useEffect } from "react";
import Modal from "../comomComponens/modal";

import { query_app } from "../api";
import { create_update_app } from "../api";

export default function AppTable({ canManage = false }) {
  let allApp = []
  const [rows, setRows] = useState([]);

  const [isLoading, setIsLoading] = useState("");
  const [modalOpen, setModalOpen] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [appName, setAppName] = useState("");
  const [actionId, setActionId] = useState(0);
  const [shopName, setShopName] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [sharedSecret, setSharedSecret] = useState("");

  const queryApp = async () => {
    try {
      setIsLoading(true);
      const params = {};
      const response = await query_app(params);
      if (response.status === 200) {
        allApp = response.data;
        const tableRows = response.data.map((item) => {
          const app_name = item.app_name ? item.app_name : "";
          const shop_name = item.shop_name ? item.shop_name : "";
          const api_key = item.api_key ? item.api_key : "Restricted";
          const shared_secret = item.shared_secret ? item.shared_secret : "Restricted";
          const status = item.is_delete ? "UnInstall" : "Installed";
          const action = canManage && (
            <Button
              onClick={() => {
                actionAppInfo(item.id);
              }}
              key={item.id}
            >
              Action
            </Button>
          );
          return [app_name, shop_name, api_key, shared_secret, status, action];
        });
        setRows(tableRows);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const saveAppInfo = async () => {
    setModalLoading(true);
    const params = {
      id: actionId,
      app_name: appName,
      api_key: apiKey,
      shared_secret: sharedSecret,
      shop_name: shopName,
    };
    const response = await create_update_app(params);
    if (response.status === 200) {
      initParams();
      setModalOpen(false);
    }
    setModalLoading(false);
    queryApp()
  };
  const initParams = () => {
    setAppName("");
    setShopName("");
    setApiKey("");
    setActionId("");
    setSharedSecret("");
  };
  const actionAppInfo = (id) => {
    setActionId(id);
    const item = allApp.find((item) => item.id === id);
    setAppName(item.app_name);
    setShopName(item.shop_name);
    setApiKey(item.api_key || "");
    setSharedSecret(item.shared_secret || "");
    setModalOpen(true);
  };
  useEffect(() => {
    queryApp();
  }, []);

  return (
    <Layout>
      <Layout.AnnotatedSection>
        <LegacyCard>
          <DataTable
            columnContentTypes={["text", "text", "text", "text", "text"]}
            loading={isLoading}
            headings={[
              "App Name",
              "Shop Name",
              "Api Key",
              "Shared Secret",
              "Status",
              "Action",
            ]}
            rows={rows}
          />
        </LegacyCard>
      </Layout.AnnotatedSection>
      <Modal open={modalOpen}>
        <BlockStack gap="200">
          <Text as="h2" variant="headingSm">
            App Info
          </Text>
          <BlockStack gap="200">
            <BlockStack gap="200">
              <TextField
                value={appName}
                onChange={(value) => {
                  setAppName(value);
                }}
                label="App Name"
              />
              <TextField
                value={shopName}
                onChange={(value) => {
                  setShopName(value);
                }}
                label="Shop Name"
              />
              <TextField
                value={apiKey}
                onChange={(value) => {
                  setApiKey(value);
                }}
                label="Api Key"
              />
              <TextField
                value={sharedSecret}
                onChange={(value) => {
                  setSharedSecret(value);
                }}
                label="Shared Secret"
              />
            </BlockStack>
          </BlockStack>
          <InlineStack align="end">
            <ButtonGroup>
              <Button
                variant="secondary"
                onClick={() => {
                  setModalOpen();
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={!shopName || !apiKey || !sharedSecret}
                variant="primary"
                onClick={() => {
                  saveAppInfo();
                }}
                loading={modalLoading}
              >
                Save
              </Button>
            </ButtonGroup>
          </InlineStack>
        </BlockStack>
      </Modal>
    </Layout>
  );
}
